/* eslint-disable no-param-reassign */
import React, { Component } from 'react';

import {
  withValue,
  withCheckedValue,
  withCheckedBinaryValue,
  withBinaryValue,
} from 'utils/redux-form-helpers';
import { ACTION_NAME_TO_DISPLAY } from 'containers/pages/Roles/AdvancedRoles/ManageRole/ModelsPermissions/duck/selectors';

import SelectorComponent from './SelectorComponent';
import styles from './PermissionsSelector.scss';

const SelectWithValue = withValue(SelectorComponent);
const SelectWithBinaryArray = withBinaryValue(SelectorComponent);
const CheckboxWithValue = withCheckedValue(SelectorComponent);
const CheckboxtWithBinaryArray = withCheckedBinaryValue(SelectorComponent);

const isCheckbox = (options) => options.length === 1;

const shouldAllowSelecting = (row, name) => {
  // @TODO Rework to take into account dropdown
  const actions =
    row.allowed_actions && row.allowed_actions.map((a) => a.split('-')[0]);

  return (
    !actions ||
    !name ||
    row.scope ||
    actions.map((a) => ACTION_NAME_TO_DISPLAY[a] || a).includes(name)
  );
};

export default class PermissionsSelector extends Component {
  getDefaultValue(options) {
    const { defaultOption = {} } = this.props;

    return isCheckbox(options) ? options[0].value : defaultOption.value;
  }

  render() {
    const { actionNames, options, rowData, className } = this.props;

    Object.keys(options).forEach((key) => {
      if (Array.isArray(options[key])) {
        options[key].forEach((type) => {
          switch (type.label) {
            case 'All':
              type.label = 'Yes';
              delete type.tooltip;
              break;
            case 'None':
              type.label = 'No';
              delete type.tooltip;
              break;
            case 'Owner':
              type.label = 'Owner Only';
              delete type.tooltip;
              break;
            default:
              break;
          }
        });
      }
    });

    if (!actionNames) {
      const ComponentWithValue = isCheckbox(options)
        ? CheckboxWithValue
        : SelectWithValue;

      return (
        <ComponentWithValue
          {...this.props}
          defaultValue={this.getDefaultValue(options)}
        />
      );
    }

    return (
      <div
        className={styles.permissionsSelectors}
        onClick={(e) => e.stopPropagation()}
        role="presentation"
        data-testid="PlatformAdminUI-PermissionSelector-Div"
      >
        {this.props.actionNames.map((actionName) => {
          const opts = options[actionName];
          const ComponentBinaryArray = isCheckbox(opts)
            ? CheckboxtWithBinaryArray
            : SelectWithBinaryArray;

          return (
            <div key={actionName} className={className}>
              {shouldAllowSelecting(rowData, actionName) && (
                <ComponentBinaryArray
                  {...this.props}
                  defaultValue={this.getDefaultValue(opts)}
                  options={opts}
                  label={actionName}
                  key={actionName}
                  name={actionName}
                  rowData={rowData}
                  change
                />
              )}
            </div>
          );
        })}
      </div>
    );
  }
}
